const showField = value => value === false;
const booleans = [{ value: true, label: "Ja" }, { value: false, label: "Nein" }];
const janein = value => (value === null || value === undefined) ? "" : value ? "Ja" : "Nein";

export const schema = {
  displayName: "PR Entscheidung",
  table: [
    {
      field: "apr_aid",
      readonly: true,
      hideFromDetail: true,
      hideFromEditor: () => true,
    },
    {
      field: "apr_stimmtmassnahmezu",
      display: "PR stimmt Maßnahme zu",
      type: "radio",
      selector: janein,
      choices: booleans,
      required: true,
    },
    {
      field: "apr_stimmtmassnahmezubegr",
      display: "Begründung der Ablehnung der Maßnahme",
      type: "textarea",
      hideFromEditor: entity => !showField(entity.apr_stimmtmassnahmezu),
      hideFromDetail: entity => !showField(entity.apr_stimmtmassnahmezu),
      rows: 5,
      required: true,
    },
    {
      field: "apr_stimmteingruppierungzu",
      display: "PR stimmt Eingruppierung zu",
      type: "radio",
      selector: janein,
      choices: booleans,
      required: true,
      helpText: <><b>Hinweis:</b>: Sollte „Eingruppierung“ im vorliegenden Fall nicht zutreffend sein, bitte „ja“ aktivieren.</>,
      helpTextReadonly: entity => entity.apr_stimmteingruppierungzu != null ? <><br /><b>Hinweis:</b>: Sollte „Eingruppierung“ im vorliegenden Fall nicht zutreffend sein, bitte „ja“ aktivieren.</> : null,
    },
    {
      field: "apr_stimmteingruppierungzubegr",
      display: "Begründung der Ablehnung der Eingruppierung",
      type: "textarea",
      hideFromEditor: entity => !showField(entity.apr_stimmteingruppierungzu),
      hideFromDetail: entity => !showField(entity.apr_stimmteingruppierungzu),
      rows: 5,
      required: true,
    },
    {
      field: "apr_stimmtbefristungzu",
      display: "PR stimmt Befristung zu",
      type: "radio",
      selector: janein,
      choices: booleans,
      required: true,
      helpText: <><b>Hinweis:</b>: Sollte „Befristung“ im vorliegenden Fall nicht zutreffend sein, bitte „ja“ aktivieren.</>,
      helpTextReadonly: entity => entity.apr_stimmtbefristungzu != null ? <><br /><b>Hinweis:</b>: Sollte „Befristung“ im vorliegenden Fall nicht zutreffend sein, bitte „ja“ aktivieren.</> : null,
    },
    {
      field: "apr_stimmtbefristungzubegr",
      display: "Begründung der Ablehnung der Befristung",
      type: "textarea",
      hideFromEditor: entity => !showField(entity.apr_stimmtbefristungzu),
      hideFromDetail: entity => !showField(entity.apr_stimmtbefristungzu),
      rows: 5,
      required: true,
    },

  ],
};
